import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { beforeImageUpload } from '../../utilities/imageUpload';
import { uploadTrainerImage } from '../../services/trainerServices';
import { UploadOutlined } from '@ant-design/icons';
import { addUnitOffer } from '../../services/unitOfferService';
import { saveAs } from 'file-saver';

import { countryList } from '../../data/countryList';
import { getPrices } from '../../services/pricing.service';
import { generateFreeworkshop } from '../../services/freeworkshop.service';
import ImageUploadSection from '../../components/ImageUploadSection';
import {
  renderTrainerForm,
  fetchTrainers,
  renderTrainerPick
} from '../../components/TrainerPage/TrainerHelpers';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {
  renderCourseFormForFreeWorkshops,
  renderCourseOfferFormForFreeWorkshops,
  formatData,
  formatSingleUnitOfferPayload,
  FREE_WORKSHOP_COURSE_PRICE_TYPE,
  renderSubunitForFreeWorkshop,
  dateFormat
} from './FreeworkshopHelpers';
import {
  Form,
  Row,
  Switch,
  Col,
  Select,
  Input,
  Upload,
  InputNumber,
  Button,
  Divider,
  Typography,
  Spin,
  Collapse
} from 'antd';
import './AddFreeworkshop.css';
const { Panel } = Collapse;
const { Text } = Typography;
const { Option } = Select;

const AddFreeworkshop = ({}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [freeCoursePrice, setFreeCoursePrice] = useState(null);
  const [unitCount, setUnitCount] = useState(0);
  const [freeworkshopData, setFreeworkshopData] = useState({});
  const [insertedUnits, setInsertedUnits] = useState([]);
  const [trainerExists, setTrainerExists] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const countryListMenu = countryList.map((country) => (
    <Option value={country.id}>{country.name}</Option>
  ));

  const onImageUpload = async (e) => {
    const formData = new FormData();
    formData.append('name', e.file.name);
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'avatar')
      .then((res) => {
        console.log(
          'initial values about to reset onimageupload',
          initialValues,
          res.data.imageUrl
        );
        setInitialValues({
          ...initialValues,
          profileImage: res.data.imageUrl
        });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  useEffect(() => {
    form.setFieldsValue({
      profileImage: initialValues.profileImage
    });
  }, [initialValues]);

  const onSubmit = async (values) => {
    setIsLoading(true);
    const valuesWithPricingOption = {
      ...values,
      pricingOption: freeCoursePrice
    };
    delete values.startDate; //Temporary, start date isn't part of the JSON
    var blob = new Blob([JSON.stringify(values)], {
      type: 'application/json'
    });
    saveAs(blob, `${Date.now()}-freeworkshop-auto-gen.json`);
    const generateFreeworkshopPayload = formatData(
      trainerExists,
      valuesWithPricingOption
    );
    setInsertedUnits([generateFreeworkshopPayload.unit]);
    await generateFreeworkshop(generateFreeworkshopPayload)
      .then((response) => {
        setFreeworkshopData(response.data);
      })
      .catch((err) => {
        alert(err);
        setIsLoading(false);
        setStatus({
          type: 'ERROR',
          message:
            'Error! something wrong when generating the course Offer!'
        });
      });
  };

  useEffect(() => {
    const courseOfferId = freeworkshopData?.courseOffer;
    const unitCreated = freeworkshopData?.unit;

    if (unitCreated) {
      const unitOfferPayload = formatSingleUnitOfferPayload(
        unitCreated,
        courseOfferId
      );
      addUnitOffer(unitOfferPayload)
        .then((res) => {})
        .catch((err) => {
          alert(err);
          setStatus({
            type: 'ERROR',
            message:
              'Error happened while creating unit offer! go and set it manually!'
          });
        });
      setIsLoading(false);

      if (status.type !== 'ERROR')
        setStatus({ type: 'SUCCESS', message: 'Successfully generated' });
    }
  }, [freeworkshopData]);

  useEffect(() => {
    fetchFreePricingOption();
    fetchTrainers(setTrainers);
  }, []);

  const fetchFreePricingOption = async () => {
    await getPrices(0, 0, { type: FREE_WORKSHOP_COURSE_PRICE_TYPE })
      .then((response) => {
        if (response.data.totalCount !== 1)
          throw new Error('Error when fetching free pricing option!');
        setFreeCoursePrice(response.data.paginatedList[0]._id);
      })
      .catch((e) => {
        setStatus({
          type: 'ERROR',
          message: 'Something wrong with fetching price.'
        });
      });
  };

  return (
    <>
      <h1>Create Workshop! </h1>
      <h1>
        This is a quick one-form way to create a <bold>new</bold> workshop
        for a new creator or existing creator!
      </h1>
      <Divider />
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <Form
          forceRender={true}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14 }}
          onFinish={onSubmit}
          initialValues={initialValues}
          form={form}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <h2 style={{ marginRight: '10px' }}>
              If on production, load the same Json file that was generated
              when you created on development
            </h2>
            <Upload
              accept=".json, .txt"
              showUploadList={false}
              beforeUpload={(file) => {
                const reader = new FileReader();

                reader.onload = (e) => {
                  //ToDo reshape date
                  form.setFieldsValue({ ...JSON.parse(e.target.result) });
                  setInitialValues({ ...JSON.parse(e.target.result) });
                };
                reader.readAsText(file);

                // Prevent upload
                return false;
              }}>
              <h1>
                <Button icon={<UploadOutlined />}>
                  Click to Upload <strong> Json </strong>
                </Button>
              </h1>
            </Upload>
          </div>
          <Divider
            style={{
              height: 5,
              color: '#333',
              backgroundColor: '#333'
            }}
          />
          <h2>User/Trainer Details!</h2>

          <div
            style={{
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'left'
            }}>
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              defaultChecked
              onChange={(e) => {
                setTrainerExists(!trainerExists);
              }}
            />
            <h3 style={{ marginLeft: '10px', color: 'darkRed' }}>
              disable this box if it is an already-existing trainer,
              creating a new workshop, and choose that trainer!
            </h3>
          </div>

          {!trainerExists ? (
            renderTrainerForm(form, onImageUpload)
          ) : (
            <>
              {renderTrainerPick(
                trainers,
                trainerExists,
                'trainerObjectId'
              )}
            </>
          )}
          <Divider
            style={{
              height: 5,
              color: '#333',
              backgroundColor: '#333'
            }}
          />
          <h3>Unit/Unit Offer Details!</h3>
          <>
            <section>
              <Form.Item
                label="Title"
                name={'unitTitle'}
                rules={[
                  {
                    required: true,
                    message: 'Please input title!'
                  }
                ]}>
                <Input />
              </Form.Item>
              <Form.Item
                label="Description"
                name={'unitDescription'}
                rules={[
                  {
                    required: false,
                    message: 'Please input code description!'
                  }
                ]}>
                <Input />
              </Form.Item>
            </section>
            <Form.Item rules={[{ required: true, message: 'By who?!' }]}>
              <Collapse>
                <Panel
                  header="imgData (Unit image in learning portal)"
                  key="2"
                  forceRender={true}>
                  <section>
                    <ImageUploadSection
                      beforeImageUpload={beforeImageUpload}
                      nest={['imgData']}
                      path={`na-portal/liveUnitThumbnails/`}
                      bucket={'image-assets.nasdaily.com'}
                      setStatus={setStatus}
                      hideResolution={{ mobile: true, desktop: true }}
                      form={form}
                      showWebP={false}
                      imgRequired={false}
                    />
                  </section>
                </Panel>
              </Collapse>
            </Form.Item>
          </>
          {renderSubunitForFreeWorkshop(form, setStatus)}
          <Divider
            style={{
              height: 5,
              color: '#333',
              backgroundColor: '#333'
            }}
          />
          <h3>Course Details!</h3>
          {renderCourseFormForFreeWorkshops(form, setStatus)}
          <Divider
            style={{
              height: 5,
              color: '#333',
              backgroundColor: '#333'
            }}
          />
          <h3>Course Offer Details!</h3>
          {renderCourseOfferFormForFreeWorkshops(
            unitCount,
            form,
            setStatus
          )}
          <Divider
            style={{
              height: 5,
              color: '#333',
              backgroundColor: '#333'
            }}
          />
          {isLoading ? (
            <>
              <div
                style={{
                  textAlign: 'center'
                }}>
                <Text type="danger">
                  Free workshop being generated! Don't close this window!!
                </Text>
                <Spin />
              </div>
            </>
          ) : null}
          {status.type === 'ERROR' ? (
            <Text type="danger">{status.message}</Text>
          ) : null}
          {status.type === 'SUCCESS' ? (
            <Text type="success">Successfully Updated!</Text>
          ) : null}
          <Row justify="end">
            <Col>
              <Button type="primary" htmlType="submit">
                {'Create Free Workshop'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  courseOffer: state.courseOffer.courseOffer,
  success: state.courseOffer.success,
  errors: state.courseOffer.errors,
  loading: state.courseOffer.loading,
  unitOffers: state.unitOffer.unitOffers
});

export default connect(mapStateToProps)(withRouter(AddFreeworkshop));
